import { useTranslation } from "react-i18next";
import { CopyButton } from "@/components/shared/copy-button";
import { cn } from "@/lib/utils";

/**
 * A short identifier next to its copy button — registration number, invoice
 * number, draft ID.
 *
 * Renders `fallback` when there is nothing to copy: an appointment with no
 * linked draft or no invoice gets the same dash as any other missing field,
 * not a button that would put an empty string on the clipboard.
 */
export default function CopyableValue({
	value,
	fallback = "N/A",
	className,
}: {
	value?: string | null;
	fallback?: string;
	className?: string;
}) {
	const { t } = useTranslation("appointments", { useSuspense: false });

	if (!value) {
		return <span className={className}>{fallback}</span>;
	}

	return (
		<span
			className={cn(
				"inline-flex items-center gap-1.5 font-semibold text-sm",
				className,
			)}
		>
			{value}
			<CopyButton value={value} label={t("common.copy_value", { value })} />
		</span>
	);
}
